import BaseEvent from './base_event';

export default class SpaceStationEvent extends BaseEvent {

    static canOccur(gameState) {
        return !gameState.eventsResults.space_station;
    }

    enter(gameState) {
        gameState.eventsResults.space_station = true;

        this.ui.showDialog({
            message: `You pass by a lone space station, when someone contacts you over the radio and asks for help. They have a giant space spiders situation and need help badly. What to do?`,
            options: [{
                text: `Here, have this* chair*. It always helps me to deal with alien menace.`,
                condition: gameState.has('chair'),
                callback: () => {
                    gameState.appendEnergy(100);
                    gameState.history.push({ id: 'spdr', msg: `shared a chair with those who needed it` });
                    this.ui.showDialog({
                        message: `Everyone knows that throwing chairs at giant space spiders is the best way to deal with them. Grateful inhabitants give you a full energy refill.`,
                        status: "Energy restored"
                    }, () => {
                        gameState.remove('chair');
                        this.end();
                    });
                }
            }, {
                text: `I’ll help you! Let’s make a surgical strike on a spider nest.`,
                callback: () => {
                    let dice_roll = game.rnd.frac();

                    if (dice_roll < 0.5) {
                        gameState.appendEnergy(20);
                        gameState.history.push({ id: 'spdr', msg: `led a spider extermination party` });
                        this.ui.showDialog({
                            message: `You lead the local militia right into the webby lair of disgusting arachnoids, burning everything with flamethrowers and plasma grenades. Unfortunately, lots of good men die there. If only you had your trusty chair with you.. Well, at least the spider carapaces are a decent fuel.`,
                            status: "+20% Energy"
                        }, this.end);
                    } else {
                        gameState.distanceLeft += 1;
                        gameState.history.push({ id: 'spdr', msg: `blown up a civil station in a retrogaming flashback` });
                        this.ui.showDialog({
                            message: `Old military instincts kicked in, you deal with spiders quickly and effectively, penetrate the defences, and kill the queen. Time bomb set, get out fast! You manage to escape the station and fly to the safe distance just before everything explodes. Clean work. For a second you feel like you forgot about something, but the feeling quickly fades away.`,
                            status: "+1 Light Year,\nnegative karma"
                        }, () => {
                            gameState.badKarma = true;
                            this.end()
                        });
                    }
                }
            }, {
                text: `Sorry, I don’t feel like a spider exterminator today`,
                condition: gameState.energy >= 10,
                callback: () => {
                    gameState.energy -= 10;
                    gameState.history.push({ id: 'spdr', msg: `was afraid of spiders` });
                    this.ui.showDialog({
                        message: `You apologize and quickly accelerate your ship. Last thing you want right now is a spider’s nest in your cargo bay.`,
                        status: "-10% Energy"
                    }, this.end);
                }
            }]
        });
    }


}



// WEBPACK FOOTER //
// ./src/states/events/space_station.js